import { IconButton, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import React, { FC } from 'react';

type CollectiveInvoicesItemProps = {
    clinicId: string;
    clinicName: string;
    onClinicRemove: (clinicName: string) => void;
};

const CollectiveInvoicesItem: FC<CollectiveInvoicesItemProps> = ({
    clinicName,
    clinicId,
    onClinicRemove,
}: CollectiveInvoicesItemProps) => {
    return (
        <ListItem disablePadding>
            <ListItemIcon>
                <IconButton onClick={() => onClinicRemove(clinicId)} aria-label="delete">
                    <DeleteIcon />
                </IconButton>
            </ListItemIcon>
            <ListItemText>{clinicName}</ListItemText>
        </ListItem>
    );
};

export default CollectiveInvoicesItem;
